export default "__VITE_ASSET__BqRAmgl5__";